import { useContext } from 'react';
import { Grid, TextField } from '@material-ui/core';
import { productInfoContext } from '../ProductCheckContext';
import { FilterContainer, SearchButton } from 'components';


let Filters = () => {
    let service = useContext(productInfoContext);

    return (
        <FilterContainer onSubmit={() => service.doSearch()}>
            <Grid item xs={2}>
                <TextField
                    variant="outlined"
                    label="SKU, EAN or UPC"
                    value={service.productSearch}
                    onChange={(e: any) => service.updateSearch(e.target.value)}
                />
            </Grid>
            <Grid item xs>
                <SearchButton type="submit" />
            </Grid>
        </FilterContainer>
    )
}

export default Filters;